import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserUtils } from '@azure/msal-browser';
import { HashRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './App.css';
import App from './App';
import AuthService from './services/AuthService';
import registerAxiosInterceptors from './services/RegisterAxiosInterceptors';

function Root() {
  const [isAuthReady, setIsAuthReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    AuthService.initialize()
      .catch((error) => {
        console.error('Unable to initialize authentication.', error);
        AuthService.logoutLocal();
      })
      .finally(() => mounted && setIsAuthReady(true));
    return () => { mounted = false; };
  }, []);

  if (!isAuthReady) return <div className="session-status" role="status">Checking your session...</div>;
  return <HashRouter><App /></HashRouter>;
}

// MSAL reads the response hash from its hidden iframe. Starting authentication or
// the hash router here can remove that response before the parent window reads it.
if (!BrowserUtils.isInIframe()) {
  registerAxiosInterceptors();
  ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><Root /></React.StrictMode>);
}
